import React from "react";

export default function Pricing() {
  const services = [
    { name: "Разработка и внедрение ИИ - агентов", price: "155 000 ₽", oldPrice: "175 000 ₽", badge: "Топ" },
    { name: "Внедрение CRM для эффективного управления", price: "145 000 ₽", oldPrice: "155 000 ₽" },
    { name: "Создание и поддержка Интернет-магазина", price: "100 000 ₽", oldPrice: "110 000 ₽" },
    { name: "Создание веб-сайта", price: "80 000 ₽", oldPrice: "82 000 ₽" },
    { name: "Настройка сервера, виртуализация, резервирование", price: "45 000 ₽", oldPrice: "57 000 ₽" },
    { name: "Настройка рабочего места уполномоченного сотрудника", price: "35 000 ₽", oldPrice: "40 000 ₽" },
    { name: "Подбор комплектующих, закупка и настройка сервера", price: "30 000 ₽", oldPrice: "37 000 ₽" },
    { name: "Техподдержка Вашего Интернет-магазина.", price: "30 000 ₽", oldPrice: "35 000 ₽" },
    { name: "Внедрение Linux (Astra, RedOS, Rosa). Импортозамещение.", price: "25 900 ₽", oldPrice: "30 000 ₽" },
    { name: "Комплексное ИТ-сопровождение деятельности на 12 месяцев", price: "990 000 ₽", oldPrice: "1 200 000 ₽", sku: "complex001" },
  ];

  // ИСПРАВЛЕННАЯ ФУНКЦИЯ: передает данные через CustomEvent
  const handleOrder = (serviceName) => {
    // 1. Отправляем событие с названием услуги напрямую в форму
    const event = new CustomEvent("selectService", { detail: serviceName });
    window.dispatchEvent(event);

    // 2. Скроллим к форме
    const contacts = document.getElementById("contacts");
    if (contacts) {
      contacts.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="pricing" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Заголовок */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-slate-800 uppercase tracking-tight mb-4">
            Каталог услуг и цены
          </h2>
          <p className="text-slate-600 text-lg">
            Прозрачная стоимость ИТ-решений и интеграций для вашего бизнеса.
          </p>
        </div>

        {/* Сетка списка услуг */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white border border-slate-100 p-6 rounded-2xl shadow-sm hover:shadow-md transition-all flex flex-col justify-between group"
            >
              <div>
                <div className="flex justify-between items-start gap-4 mb-3">
                  <h3 className="font-bold text-slate-800 group-hover:text-blue-600 transition-colors text-base md:text-lg leading-snug">
                    {service.name}
                  </h3>
                  {service.badge && (
                    <span className="bg-blue-50 text-blue-600 text-xs font-bold px-2.5 py-1 rounded-md uppercase tracking-wider shrink-0">
                      {service.badge}
                    </span>
                  )}
                </div>
                {service.sku && (
                  <p className="text-xs text-slate-400 font-mono mb-4">Артикул: {service.sku}</p>
                )}
              </div>

              <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-50">
                <div className="flex flex-col">
                  <span className="text-2xl font-black text-slate-900 tracking-tight">
                    {service.price}
                  </span>
                  <span className="text-sm text-slate-400 line-through">
                    {service.oldPrice}
                  </span>
                </div>
                
                <button
                  onClick={() => handleOrder(service.name)}
                  className="bg-slate-900 hover:bg-blue-600 text-white px-5 py-2.5 rounded-xl text-xs font-bold transition-all uppercase tracking-wider"
                >
                  Заказать
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
